/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://tayv767jsjfa3jrxfpxak3ezrm.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-wh7asb3pxvbhxbmcqjnbgvhxxq",
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "DoctorRequisitions-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "Doctors-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "DoctorEvents-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "DoctorLicenses-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "DoctorTestTypes-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "DoctorRequisitionNotes-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "DoctorConsults-prod",
            "region": "us-east-1"
        }
    ]
};


export default awsmobile;
